export default __webpack_public_path__ + "static/media/ArrowRight.1292c7d6.svg";